import { studentTestView, testsInStudentOrder } from '../../../session/testVisibility'

// Dynamically maps test cases to their results.
// Public tests come first, named "Example #N" with their input and expected output; hidden
// tests (every test without `hidden: false`) keep their name. `index` is the row's place in
// session.test_list, which results are matched by; a list without public tests comes back
// in its saved order with the same names as before (testVisibility.js).
// `outcomes` (TerminalContext's testOutcomes, optional): how each test ended; a failed visible
// test also gets what it said (the assert's message, or the error), a hidden one never does.
export const formatTestsForRender = (session, currentTestResults, outcomes = []) => {
    const dbTests = session?.test_list || [];

    return testsInStudentOrder(dbTests).map(({ test: def, index }) => {
        const view = studentTestView(dbTests, index, def.test_name || `Test Case ${index + 1}`)
        const outcome = Array.isArray(outcomes) ? outcomes[index] : null
        const said = !view.hidden && outcome && (outcome.status === 'assertion_failed' || outcome.status === 'error')
            ? (outcome.status === 'error' ? [outcome.errorType, outcome.message].filter(Boolean).join(': ') : outcome.message) || null
            : null
        return {
            testName: view.name,
            view,
            index,
            result: currentTestResults[index] !== undefined ? currentTestResults[index] : null,
            status: outcome?.status || null,
            message: said
        }
    })
}
